import { makeStyles } from "@inductiveautomation/ws-components";

export const getEmailPreferencesFormStyles = makeStyles()((theme) => ({
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    marginBottom: "0.5rem",
    width: "100%",
  },
  footnote: {
    ...(theme.typography.subtitle as React.CSSProperties),
    a: {
      ...(theme.typography.subtitle as React.CSSProperties),
    },
  },
  actions: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
    [theme.breakpoints.down(768)]: {
      width: "100%",
      justifyContent: "center",
      flexDirection: "column",
      button: {
        width: "100%",
      },
    },
    marginBottom: "0.5rem",
  },
}));
